package com.hyperether.goodjob.scenes.pricing

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Icon
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.paint
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.coerceAtLeast
import androidx.compose.ui.zIndex
import com.hyperether.goodjob.models.Plan
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.check_circle
import com.hyperether.goodjob.resources.choose_plan
import com.hyperether.goodjob.resources.managers
import com.hyperether.goodjob.resources.month
import com.hyperether.goodjob.resources.most_popular
import com.hyperether.goodjob.resources.premium_dark
import com.hyperether.goodjob.resources.users
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.LandingPageBg
import com.hyperether.goodjob.theme.PopularPricingText
import com.hyperether.goodjob.theme.PricingBoxBg
import com.hyperether.goodjob.theme.PricingBtnColor
import com.hyperether.goodjob.theme.PricingText
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.currentLanguage
import com.hyperether.resources.stringResource
import com.hyperether.resources.stringResourcePlain
import org.jetbrains.compose.resources.painterResource
import kotlin.math.roundToInt

@Composable
fun PricingPlansWeb(
    isPricingScreen: Boolean = false,
    planList: List<Plan>,
    onChoosePlan: (Plan) -> Unit = {}
) {
    BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
        val cardWidth = 280.toScaleDp()
        val cardHeight = if (isPricingScreen) 480.toScaleDp() else 420.toScaleDp()
        val spacing = 40
        val columns =
            (maxWidth.value.roundToInt() / (cardWidth.value.roundToInt() + spacing)).coerceAtLeast(1)

        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            val cardModifier = Modifier.width(cardWidth).height(cardHeight)

            if (columns >= 4) {
                BoxWithConstraints(
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(
                            Color(0xFF1A1D24),
                            shape = RoundedCornerShape(24.toScaleDp())
                        )

                ) {
                    val padding = 16.toScaleDp()
                    val cardsInRow = 4
                    val totalPadding = padding * (cardsInRow - 1)
                    val cardWidthRow =
                        ((maxWidth - totalPadding) / cardsInRow).coerceAtLeast(280.toScaleDp())
                    val aspectRatio = if (isPricingScreen) 1.6f else 1.4f
                    val cardHeightRow = cardWidthRow * aspectRatio


                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(padding),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        planList.forEach { plan ->
                            if (plan.isPopular == true) {
                                Box(
                                    modifier = Modifier
                                        .width(cardWidthRow)
                                        .height(cardHeightRow)
                                        .offset(y = (-65).toScaleDp())
                                        .zIndex(1f)
                                ) {
                                    PricingCard(
                                        isPricingScreen = isPricingScreen,
                                        plan = plan,
                                        onChoosePlan = onChoosePlan
                                    )
                                }
                            } else {
                                Box(
                                    modifier = Modifier
                                        .width(cardWidthRow)
                                        .height(cardHeightRow)
                                ) {
                                    PricingCard(
                                        isPricingScreen = isPricingScreen,
                                        plan = plan,
                                        onChoosePlan = onChoosePlan
                                    )
                                }
                            }
                        }
                    }
                }
            } else if (columns == 3) {
                Column(verticalArrangement = Arrangement.spacedBy(16.toScaleDp())) {
                    Row(horizontalArrangement = Arrangement.spacedBy(16.toScaleDp())) {
                        planList.take(3).forEach { plan ->
                            Box(modifier = cardModifier) {
                                PricingCard(
                                    isPricingScreen = isPricingScreen,
                                    plan = plan,
                                    onChoosePlan = onChoosePlan
                                )
                            }
                        }
                    }
                    Row(horizontalArrangement = Arrangement.spacedBy(16.toScaleDp())) {
                        planList.drop(3).forEach { plan ->
                            Box(modifier = cardModifier) {
                                PricingCard(
                                    isPricingScreen = isPricingScreen,
                                    plan = plan,
                                    onChoosePlan = onChoosePlan
                                )
                            }
                        }
                    }
                }
            } else if (columns == 2) {
                Column(verticalArrangement = Arrangement.spacedBy(16.toScaleDp())) {
                    planList.chunked(2).forEach { rowPlans ->
                        Row(horizontalArrangement = Arrangement.spacedBy(16.toScaleDp())) {
                            rowPlans.forEach { plan ->
                                Box(modifier = cardModifier) {
                                    PricingCard(
                                        isPricingScreen = isPricingScreen,
                                        plan = plan,
                                        onChoosePlan = onChoosePlan
                                    )
                                }
                            }
                        }
                    }
                }
            } else {
                Column(verticalArrangement = Arrangement.spacedBy(16.toScaleDp())) {
                    planList.forEach { plan ->
                        Box(modifier = cardModifier) {
                            PricingCard(
                                isPricingScreen = isPricingScreen,
                                plan = plan,
                                onChoosePlan = onChoosePlan
                            )
                        }
                    }
                }
            }
        }
    }
}


@Composable
fun PricingCard(
    isPricingScreen: Boolean,
    plan: Plan,
    onChoosePlan: (Plan) -> Unit
) {
    val isPopular = plan.isPopular == true
    val cardColor = if (isPopular) Color.White else Color(0xFF1A1D24)
    val textColor = if (isPopular) PopularPricingText else PricingText

    val features = listOf(
        plan.getStorage(currentLanguage.value.code).orEmpty(),
        plan.getPlanSupport(currentLanguage.value.code).orEmpty(),
        plan.limitManagers.toString() + " " + stringResource(Res.string.managers) + " + " +
                plan.limitUsers + " " + stringResource(Res.string.users)
    )

    val popularModifier = Modifier
        .shadow(
            elevation = 12.toScaleDp(),
            shape = RoundedCornerShape(25.toScaleDp())
        )
        .background(color = cardColor, shape = RoundedCornerShape(25.toScaleDp()))
        .paint(
            painter = painterResource(Res.drawable.premium_dark),
            alignment = Alignment.CenterEnd
        )
        .padding(22.toScaleDp())
        .fillMaxHeight()

    val modifier = Modifier
        .background(color = cardColor, shape = RoundedCornerShape(25.toScaleDp()))
        .padding(22.toScaleDp())
        .fillMaxHeight()

    val cardModifier = if (isPopular) popularModifier else modifier

    Column(
        modifier = cardModifier,
        verticalArrangement = Arrangement.SpaceBetween
    ) {
        if (isPopular) {
            Box(
                modifier = Modifier
                    .height(28.toScaleDp())
                    .width(122.toScaleDp())
                    .background(
                        PricingBoxBg,
                        shape = RoundedCornerShape(50.toScaleDp())
                    )
                    .align(Alignment.End),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    text = stringResource(Res.string.most_popular),
                    fontSize = 10.toScaleSp(),
                    lineHeight = 12.toScaleSp(),
                    color = Color.White,
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center,
                )
            }
        }

        Text(
            text = buildAnnotatedString {
                withStyle(
                    style = SpanStyle(
                        fontSize = 36.toScaleSp(),
                        fontWeight = FontWeight.W700,
                        color = textColor
                    )
                ) {
                    append(plan.getPriceString())
                }

                if (plan.price != 0.0) {
                    val period = stringResourcePlain(Res.string.month)
                    withStyle(
                        style = SpanStyle(
                            fontSize = 17.toScaleSp(),
                            fontWeight = FontWeight.W400,
                            color = textColor
                        )
                    ) {
                        append(" /$period")
                    }
                }
            },
            modifier = Modifier
                .align(Alignment.Start)
        )
        Spacer(modifier = Modifier.height(20.toScaleDp()))
        Text(
            text = plan.getName(currentLanguage.value.code).orEmpty(),
            fontSize = 28.toScaleSp(),
            fontWeight = FontWeight.W700,
            color = textColor,
            modifier = Modifier
                .align(Alignment.Start)
        )

        Spacer(modifier = Modifier.height(8.toScaleDp()))
        Text(
            text = plan.getDescription(currentLanguage.value.code).orEmpty(),
            lineHeight = 18.toScaleSp(),
            fontWeight = FontWeight.W400,
            fontSize = 15.toScaleSp(),
            color = textColor,
            modifier = Modifier
                .align(Alignment.Start)
        )

        Spacer(modifier = Modifier.height(16.toScaleDp()))
        features.forEach {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .align(Alignment.Start),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Icon(
                    painter = painterResource(Res.drawable.check_circle),
                    contentDescription = "Feature icon",
                    tint = if (isPopular) LandingPageBg.copy(alpha = 0.5f) else Color.White.copy(
                        alpha = 0.5f
                    ),
                    modifier = Modifier.size(20.toScaleDp())
                )

                Spacer(modifier = Modifier.width(10.toScaleDp()))

                Text(
                    text = it,
                    fontSize = 15.toScaleSp(),
                    lineHeight = 18.toScaleSp(),
                    color = textColor,
                    fontWeight = FontWeight.W400
                )
            }
        }
        Spacer(modifier = Modifier.height(16.toScaleDp()))
        if (isPricingScreen) {
            Button(
                onClick = { onChoosePlan(plan) },
                modifier = Modifier
                    .height(46.toScaleDp())
                    .fillMaxWidth()
                    .pointerHoverIcon(PointerIcon.Hand)
                    .clip(RoundedCornerShape(50.toScaleDp())),
                colors = ButtonDefaults.buttonColors().copy(
                    containerColor = if (isPopular) BlueApp else PricingBtnColor,
                    contentColor = BlueApp
                )
            ) {
                Text(
                    fontWeight = FontWeight.W700,
                    text = stringResource(Res.string.choose_plan),
                    color = PricingText,
                    fontSize = 15.toScaleSp()
                )
            }
        }
    }
}